import { isNonEmptyString, isString, isObject } from './checks'

export const transformTaxonomyList = (list = []) => {
  const filteredList = list.filter(
    (item) => isNonEmptyString(item) || (isObject(item) && 'title' in item)
  )

  const transformedList = filteredList.map((item) => {
    if (isString(item)) {
      return {
        title: item
      }
    }

    return item
  })

  return transformedList
}
